import React, { useEffect, useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import { ReactComponent as FilterIcon } from "./icons/filter.svg";
import "./HomeFilter.scss";

const HomeFilter = ({ handleFilter, initialSelect = [], list = [] }) => {
    const [open, setOpen] = useState(false);
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);

    const [select, setSelect] = useState(initialSelect);

    useEffect(() => {
        if (JSON.stringify(initialSelect) !== JSON.stringify(select)) {
            setSelect(initialSelect);
        }
    }, [initialSelect]);

    const onSelect = (e) => {
        const { target: { id } } = e;
        const value = id.toString();
        const idx = select.findIndex(el => el === value);

        let newSelect;
        if (idx === -1) {
            newSelect = [...select, value];
        } else {
            newSelect = [...select.slice(0, idx), ...select.slice(idx + 1)];
        }
        setSelect(newSelect);
        handleFilter(newSelect);
    };


    const onClearAll = () => {
        setSelect([]);
        handleFilter([]);
    };

    return (
        <div className="filter_wrap">
            <button className="filter_wrap__btn" type="button" onClick={onOpen}>
                <FilterIcon />
                <span>Фильтр</span>
                {select.length > 0 && <span className="filter_wrap__count">+{select.length}</span>}
            </button>

            {select.length > 0 && (
                <button className="filter_wrap__clear_btn" type="button" onClick={onClearAll}>
                    <span>Очистить все</span>
                </button>
            )}

            {open && (
                <ClickAwayListener onClickAway={onClose}>
                    <div className="filter_wrap__popover ">
                        <button className="filter_wrap__btn popover_btn" type="button" onClick={onClose}>
                            <FilterIcon />
                            <span>Показывать:</span>
                        </button>
                        <ul className="filter_wrap__list">
                            {list && list.map(({ id, name }) => (
                                <li key={id} className="filter_wrap__item">
                                    <input
                                        id={id}
                                        type="checkbox"
                                        value={id}
                                        onChange={onSelect}
                                        checked={select.includes(id.toString())}
                                    />
                                    <label htmlFor={id}>{name}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                </ClickAwayListener>
            )}
        </div>
    );
};

export default HomeFilter;
